export enum RoomFormTabType {
  GENERAL = "GENERAL",
  ROOM_DATA = "ROOM_DATA",
  AIR_DATA = "AIR_DATA",
  REMARK = "REMARK",
  ATTACHMENTS = "ATTACHMENTS",
  CLARIFICATION_REQUEST = "CLARIFICATION_REQUEST"
}
